import { idleState, failedState, loadingState } from "@grandvisionhq/state";
import { INIT } from "./actions.js";
import { optInsReducer, initialState as initialState$2 } from "./OptIns/OptIns/reducer.js";
import { AuthState, isLoggedIn, isUninitialized, isLoggedInPasswordless } from "./state.js";
import { userDataReducer, initialState as initialState$1 } from "./UserData/UserData/reducer.js";
import { RECOVER_SESSION_FAILED, PARSE_HASH_FAILED, PARSE_HASH_SUCCEEDED, LOGIN_FAILED, LOGIN } from "./Login/Login/actions.js";
import { CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILED, CHANGE_PASSWORD, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAILED, UPDATE_PASSWORD, RESET_PASSWORD_FAILED, RESET_PASSWORD_SUCCESS, RESET_PASSWORD } from "./ResetPassword/ResetPassword/actions.js";
import { SIGNUP_FAILED, SIGNUP_SUCCESS, SIGNUP, SET_PASSWORD_SUCCESS, SET_PASSWORD_FAILED, SET_PASSWORD } from "./CreateAccount/CreateAccount/actions.js";
const initialState = {
  state: AuthState.Uninitialized
};
function fail(union) {
  throw new Error(`Should also account for ${union}`);
}
function reducer(state = initialState, action) {
  switch (action.type) {
    case INIT:
      const {
        apiUrl,
        domain,
        clientId,
        customDomain,
        routes,
        basePath,
        optIns = [],
        userSettings = {
          optInsState: initialState$2,
          userDataState: initialState$1
        },
        checkoutRoute,
        putPrescriptionTokensOnCart = false,
        disableAddressEditing = false,
        supportFeaturesLinks = []
      } = action.payload;
      return {
        state: AuthState.Initialized,
        apiUrl,
        domain,
        clientId,
        customDomain,
        routing: {
          basePath,
          routes,
          checkoutRoute
        },
        optIns,
        userSettings,
        loginCall: idleState(),
        signupCall: idleState(),
        resetPasswordCall: idleState(),
        putPrescriptionTokensOnCart,
        disableAddressEditing,
        supportFeaturesLinks
      };
    case SET_PASSWORD:
      if (!isLoggedInPasswordless(state)) {
        throw new Error(
          `Can only dispatch ${SET_PASSWORD} when user is logged in with passwordless flow`
        );
      }
      return {
        ...state,
        activateCall: loadingState()
      };
    case SET_PASSWORD_FAILED:
      const { error } = action;
      if (!isLoggedInPasswordless(state)) {
        throw new Error(
          `Can only dispatch ${SET_PASSWORD_FAILED} when user is logged in with passwordless flow`
        );
      }
      return {
        ...state,
        activateCall: failedState(error)
      };
    case SET_PASSWORD_SUCCESS:
      if (!isLoggedInPasswordless(state)) {
        throw new Error(
          `Can only dispatch ${SET_PASSWORD_SUCCESS} when user is logged in with passwordless flow`
        );
      }
      return {
        ...state,
        activateCall: idleState(),
        hasActivatedAccount: true
      };
    case SIGNUP:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        signupCall: loadingState()
      };
    case SIGNUP_SUCCESS:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        signupCall: idleState()
      };
    case SIGNUP_FAILED:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        signupCall: failedState(action.error)
      };
    case RESET_PASSWORD:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        resetPasswordCall: loadingState()
      };
    case RESET_PASSWORD_SUCCESS:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        resetPasswordCall: idleState()
      };
    case RESET_PASSWORD_FAILED:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        resetPasswordCall: failedState(action.error)
      };
    case UPDATE_PASSWORD:
      if (!isLoggedInPasswordless(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        setPasswordCall: loadingState()
      };
    case UPDATE_PASSWORD_FAILED:
      if (!isLoggedInPasswordless(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        setPasswordCall: failedState(action.error)
      };
    case UPDATE_PASSWORD_SUCCESS:
      if (!isLoggedInPasswordless(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        setPasswordCall: idleState()
      };
    case CHANGE_PASSWORD:
      if (!isLoggedIn(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        changePasswordCall: loadingState()
      };
    case CHANGE_PASSWORD_FAILED:
      if (!isLoggedIn(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        changePasswordCall: failedState(action.error)
      };
    case CHANGE_PASSWORD_SUCCESS:
      if (!isLoggedIn(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return state;
    case LOGIN:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions auth is initialized`);
      }
      return {
        ...state,
        loginCall: loadingState()
      };
    case LOGIN_FAILED:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        loginCall: failedState(action.error)
      };
    case PARSE_HASH_SUCCEEDED:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      switch (action.payload.type) {
        default:
          return fail(action.payload);
        case "regular":
          return {
            ...state,
            state: AuthState.LoggedIn,
            userId: action.payload.id,
            email: action.payload.email,
            type: "regular",
            loginCall: idleState(),
            changePasswordCall: idleState()
          };
        case "passwordless":
          return {
            ...state,
            state: AuthState.LoggedIn,
            userId: action.payload.id,
            email: action.payload.email,
            type: "passwordless",
            loginCall: idleState(),
            hasActivatedAccount: action.payload.hasActivatedAccount,
            activateCall: idleState(),
            setPasswordCall: idleState()
          };
      }
    case PARSE_HASH_FAILED:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      return {
        ...state,
        state: AuthState.ParseHashFailed,
        error: action.payload.error,
        email: action.payload.email
      };
    case RECOVER_SESSION_FAILED:
      if (isUninitialized(state)) {
        throw new Error(`Can't run actions before auth is initialized`);
      }
      if (isLoggedIn(state) || isLoggedInPasswordless(state)) {
        return state;
      }
      return {
        ...state,
        state: AuthState.LoggedOut,
        error: action.error
      };
    default: {
      if (isLoggedIn(state)) {
        return {
          ...state,
          userSettings: {
            optInsState: optInsReducer(state.userSettings.optInsState, action),
            userDataState: userDataReducer(state.userSettings.userDataState, action)
          }
        };
      }
      return state;
    }
  }
}
export {
  reducer as default,
  initialState
};
//# sourceMappingURL=reducer.js.map
